<template>
    <input type="text"
           autocomplete="off"
           title="Notes"
           v-model="entry.notes"
           class="form-control"
           v-bind:class="{ 'is-invalid' : error }"
           style="min-width: 100px"
           placeholder="Notes..."
           @focusout="hideEditor"
           @keyup.enter="hideEditor"/>
    <small class="invalid-feedback d-block"
           v-show="error !== ''">
        {{ error || '' }}
    </small>
</template>

<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
        hideEditor: {
            type: Function,
            required: false,
            default: () => {}
        }
    },
}
</script>

<style scoped>

</style>
